/**
 * sudimage-agenda.js
 * @author      Marc-André Appel <marcandre.appel@gmail.com>
 * @copyright   2015 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        http://www.sudimage.com
 */
/* global $, window, document, undefined */

if (typeof SI_AGENDA_API !== 'undefined') {
    (function ($, window, document, undefined) {

        "use strict";

        var pluginName = "SudimageAgenda",
            defaults = {
                view: "calendar",
                listLength: 10,
                agendaAPI: SI_AGENDA_API,
                eventsAPI: SI_EVENTS_API,
                listAPI: SI_EVENT_LIST_API,
                headerOptions: {
                    left: 'prev today',
                    center: 'title',
                    right: 'month,agendaWeek next'
                },
                templates: {
                    options: {
                        startDateFmt: '[Le] dddd DD MMMM YYYY',
                        startDateFmtAlt: '[Du] dddd DD MMMM YYYY',
                        startTimeFmt: ' [à] HH[h]mm',
                        startTimeFmtSameDayWOEndTime: ' [à partir de] HH[h]mm',
                        startTimeFmtSameDayEndTime: ' [de] HH[h]mm',
                        endDateFmt: ' [au] dddd DD MMMM YYYY',
                        endTimeFmt: ' [à] HH[h]mm'
                    }
                },
                popup: {
                    content: {
                        shorten: 48
                    }
                },
                categoriesFilter: false,
                filterValue: 'all'
            };

        function Plugin(element, options) {
            this.element = element;

            this.settings = $.extend({}, defaults, options);
            this.elementDataSettings();
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        $.extend(Plugin.prototype, {
            dataStore: null,
            pCount: 1,
            init: function () {

                moment.locale(this.locale);
                var t = this;
                var s = this.settings;

                if (s.view == "calendar") {
                    $(this.element).fullCalendar({
                        events: {
                            url: s.agendaAPI,
                            type: 'POST',
                            data: {
                                agenda_id: s.agendaID
                            }
                        },
                        header: s.headerOptions,
                        eventClick: function (e) {
                            var d = t.getEvent(e.id)
                            t.createPopup(d, s);
                        },
                        lang: this.locale
                    });
                } else {
                    this.renderFilter();
                    this.renderList();
                }
            },
            getEvent: function (e) {
                var d;
                var s = this.settings;
                $.ajax({
                    'async': false,
                    'type': "POST",
                    'global': false,
                    'dataType': 'json',
                    'url': this.settings.eventsAPI,
                    'data': {
                        event_id: e,
                        shorten: s.popup.content.shorten
                    },
                    'success': function (j) {
                        d = j
                    }
                });
                return d;
            },
            renderList: function (d) {
                var s = this.settings;
                if (this.dataStore === null) {
                    var eventsData;
                    $.ajax({
                        'async': false,
                        'type': "GET",
                        'global': false,
                        'dataType': 'json',
                        'url': s.listAPI + '/' + s.agendaID + '/' + s.listLength + '/' + s.filterValue,
                        'data': {
                            // agenda_id: s.agendaID,
                            // start: s.listLength,
                            shorten: s.popup.content.shorten
                        },
                        'jsonp': false,
                        'success': function (json_data) {
                            eventsData = json_data;
                        }
                    });
                    this.dataStore = eventsData;
                }
                var e = this.dataStore;
                var l = 0;
                if (typeof e !== 'undefined') {
                    l = e.length;
                }
                if (l !== 0) {
                    if (typeof d !== 'undefined') {
                        if (d === 'prev') {
                            if (this.pCount !== 1) {
                                this.pCount = (this.pCount - 1);
                            }
                        } else {
                            var maxP = Math.ceil(l / s.list_limit);
                            if (this.pCount !== maxP) {
                                this.pCount = (this.pCount + 1);
                            }
                        }
                    }
                    var offset = (this.pCount - 1) * s.list_limit;
                    var fullList = '';
                    var limit = (offset + s.list_limit);
                    if (limit > e.length) {
                        limit = e.length;
                    }
                    limit--;
                    for (var i = offset; i <= limit; i++) {
                        var data = e[i];
                        var elem = s.templates.list_item;
                        var start = moment(data.start);
                        var start_time = moment(data.start).format('HH:mm');
                        var end = null;
                        var end_time = null;
                        var date = {
                            start_date: start.format(s.templates.options.startDateFmt),
                            start_time: '',
                            end_date: '',
                            end_time: ''
                        };

                        if (typeof data.end !== 'undefined' && data.end !== null) {
                            end = moment(data.end);
                            end_time = end.format('HH:mm');
                        }
                        if (end !== null) {
                            date.end_date = end.format(s.templates.options.endDateFmt);
                            date.start_date = start.format(s.templates.options.startDateFmtAlt);
                        }
                        if (start_time !== '00:00' && data.allDay === false) {
                            date.start_time = start.format(s.templates.options.startTimeFmtSameDayWOEndTime);
                            if (end_time !== null && end_time !== '00:00') {
                                date.start_time = start.format(s.templates.options.startTimeFmtSameDayEndTime);
                                date.end_time = end.format(s.templates.options.endTimeFmt);
                                if (end !== null) {
                                    date.start_time = start.format(s.templates.options.startTimeFmt);
                                }
                            }
                        }
                        data.block = s.agendaBlockID;
                        data.date = date;

                        var item = {
                            tmpl: doT.template(elem),
                            sdf: function (fmt) {
                                return moment(data.start_full).format(fmt);
                            },
                            edf: function (fmt) {
                                return moment(data.end_full).format(fmt);
                            }
                        };
                        fullList += item.tmpl(data);
                    }
                    $('*[data-si-agenda-list-items]', $(this.element)).html(fullList);
                    this.renderPagination(this.pCount, l);
                } else {
                    $('ul[data-si-agenda-list-items]', $(this.element)).html('<li class="text-center">Aucun événement prévu pour l\'instant.</li>');
                }
            },
            renderPagination: function (p, t) {
                var prev = $('*[data-si-agenda-list-pagination=prev]');
                var next = $('*[data-si-agenda-list-pagination=next]');
                var l = this.settings.list_limit;
                var maxP = Math.ceil(t / l);

                prev.removeClass('disabled');
                next.removeClass('disabled');

                if (p == 1) {
                    prev.addClass('disabled');
                }
                if (p == maxP && maxP > 1) {
                    next.addClass('disabled');
                }
                this.prepareActions();
            },
            renderFilter: function () {
                var settings = this.settings;
                var $this = this;
                var filter = $('*[data-si-agenda-list-filter]');
                filter.on('click', function (e) {
                    $this.dataStore = null;
                    e.preventDefault();
                    var filterValue = $(this).attr('data-si-agenda-list-filter');
                    settings.filterValue = filterValue;
                    var tabList = $(this).parent('li').parent('ul');
                    $('li', tabList).each(function () {
                        $(this).removeClass('active');
                    });
                    $(this).parent('li').addClass('active')
                    $this.pCount = 1;
                    $this.renderList();
                })
            },
            template: function () {

            },
            createPopup: function (data) {
                var s = this.settings;
                var agendaEventPopup = $('#sudimage-agenda-event-popup');

                $('#sudimage-agenda-event-popup-link', agendaEventPopup).hide();
                $('#sudimage-agenda-event-popup-label', agendaEventPopup).html(data.title).css({
                    color: data.textColor
                });
                $('#sudimage-agenda-event-popup-content', agendaEventPopup).html('');
                if (typeof data.file !== 'undefined') {
                    var img = $('<img>').attr('src', data.file).addClass('img-responsive').css({
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    });
                    var imgContainer = $('<div>')
                        .addClass('text-center')
                        .css({marginBottom: 20})
                        .append(img);
                    $('#sudimage-agenda-event-popup-content', agendaEventPopup).html(imgContainer);
                }
                $('#sudimage-agenda-event-popup-content', agendaEventPopup).append(data.description);
                if (typeof data.url !== 'undefined') {
                    $('#sudimage-agenda-event-popup-link', agendaEventPopup).attr('href', data.url).show();
                }
                $('#sudimage-agenda-event-popup-header', agendaEventPopup).css({
                    backgroundColor: data.backgroundColor
                });
                $('.modal-dialog-date-time', agendaEventPopup).html('');
                if (typeof data.start_date !== 'undefined') {
                    $('#start-date-formatted', agendaEventPopup).html(moment(data.start_date, 'YYYY-MM-DD').format('[Le] dddd DD MMMM YYYY'));
                }
                if (typeof data.end_date !== 'undefined') {
                    var endDate = moment(data.end_date, 'YYYY-MM-DD');
                    $('#end-date-formatted', agendaEventPopup).html(endDate.format('[au] dddd DD MMMM YYYY'));
                    $('#start-date-formatted', agendaEventPopup).html(moment(data.start_date, 'YYYY-MM-DD').format('[Du] dddd DD MMMM YYYY'));
                }
                if (typeof data.start_hour !== 'undefined') {
                    $('#start-time-formatted', agendaEventPopup).html(moment(data.start_hour, 'HH:mm:ss').format('[à partir de] HH[h]mm'));
                    if (typeof data.end_hour !== 'undefined') {
                        $('#start-time-formatted', agendaEventPopup).html(moment(data.start_hour, 'HH:mm:ss').format('[de] HH[h]mm'));
                        $('#end-time-formatted', agendaEventPopup).html(moment(data.end_hour, 'HH:mm:ss').format('[à] HH[h]mm'));
                        if (typeof data.end_date !== 'undefined') {
                            $('#start-time-formatted', agendaEventPopup).html(moment(data.start_hour, 'HH:mm:ss').format('[à] HH[h]mm'));
                        }
                    }
                }
                agendaEventPopup.modal();
            },
            addList: function (list) {
                $(this.element).html(list);
            },
            prepareActions: function () {
                $('*[data-si-agenda-popup]').on('click', function (e) {
                    e.preventDefault();
                    var event = $(this).attr('data-si-agenda-popup');
                    var i = $(this).attr('data-si-agenda-block-id');
                    var t = $('#sudimage-agenda-' + i).data('SudimageAgenda');
                    var eventData = t.getEvent(event);
                    t.createPopup(eventData);
                });
            },
            elementDataSettings: function () {
                var e = $(this.element);
                var s = this.settings;
                s.agendaBlockID = e.attr('data-si-agenda-block-id');
                s.agendaID = e.attr('data-si-agenda-id');
                s.view = e.attr('data-si-agenda');

                if (typeof e.attr('data-si-agenda-list-length') !== 'undefined') {
                    s.listLength = e.attr('data-si-agenda-list-length');
                }

                if (typeof e.attr('data-si-agenda-locale') !== 'undefined') {
                    s.locale = e.attr('data-si-agenda-locale');
                }

                if (typeof e.attr('data-si-agenda-header-options') !== 'undefined') {
                    s.headerOptions = JSON.parse(e.attr('data-si-agenda-header-options'));
                }

                if (typeof e.attr('data-si-agenda-popup-content-shorten') !== 'undefined') {
                    s.popup.content.shorten = e.attr('data-si-agenda-popup-content-shorten');
                }

                if (typeof e.attr('data-si-agenda-categories-filter') !== 'undefined') {
                    s.categoriesFilter = JSON.parse(e.attr('data-si-agenda-categories-filter'));
                }

                if (s.view === 'list') {
                    var tmpl = $('*[data-si-agenda-template=list-item]');
                    s.templates.list_item = tmpl.html();
                    s.list_limit = parseInt(e.attr('data-si-agenda-list-limit'));
                    if (typeof tmpl.attr('data-si-agenda-template-options') !== 'undefined') {
                        s.templates.options = JSON.parse(tmpl.attr('data-si-agenda-template-options'));
                    }
                }
            }
        });

        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, pluginName)) {
                    $.data(this, pluginName, new Plugin(this, options));
                }
            });
        };

    })(jQuery, window, document);


    $(document).ready(function () {
        $('*[data-si-agenda]').SudimageAgenda();


        $('*[data-si-agenda-list-pagination]').on('click', function (e) {
            e.preventDefault();
            var i = $(this).attr('data-si-agenda-block-id');
            var t = $('#sudimage-agenda-' + i).data('SudimageAgenda');
            t.renderList($(this).attr('data-si-agenda-list-pagination'));
        });
    });
}
